import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import get from 'lodash/get';
import Bio from '../components/Bio';
import { Container } from '../components/Skeleton';

const weekday =  [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
const d = new Date();

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark;
    const siteTitle = get(this.props, 'data.site.siteMetadata.title');

    return (
      <div>
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
        <Container>
          <h1>{post.frontmatter.title}</h1>
          <p>
            {post.frontmatter.date}
          </p>
          { post.frontmatter.tags ?
            <p>Tags: <span style={{fontStyle: 'italic'}}>{post.frontmatter.tags && post.frontmatter.tags.map(tag =>`${tag} `)}</span></p>
            : null
          }
          <hr/>
          <div dangerouslySetInnerHTML={{ __html: post.html }} />
          <div style={{ marginTop: 48, marginBottom: 48}}>
            <hr/>
            <p style={{ textAlign: 'center' }}>
              Thanks for reading! If you have any comments, questions or feedback
              please
              <a href="mailto:henry@henrymoulton.com"> get in contact.</a> Have a
              nice {weekday[d.getDay()]}.
            </p>
            <hr />
          </div>
          <Bio />
        </Container>
      </div>
    );
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        tags
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js